import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-10 text-sm">Verificando sesión…</div>;
  if (!user) return <Navigate to="/audit/login" state={{ from: location.pathname }} replace />;
  return children;
}
